import { Action, Dispatch } from 'redux'
import { initStoreAction } from 'reducks/store/actions'

const initStore = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initStoreAction())
  }
}

export default initStore
